<template>
  <div class="loader">
    <!-- <video
      autoplay
      loop
      muted
      src="@/assets/Images/Global/Loader.mp4"
      class="loader__video"
    ></video> -->
    <img
      src="@/assets/Images/Global/Logo.svg"
      alt=""
      class="loader__video animated"
    />
  </div>
</template>

<script>
export default {
  name: "Loader",
};
</script>

<style lang="scss" scoped>
.loader {
  width: 100dvw;
  height: 100dvh;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  &__video {
    animation: animated 0.75s ease-in-out forwards infinite alternate-reverse;
    clip-path: inset(1px 1px);
    height: 100px;
  }
}
@keyframes animated {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
